export default {
    Profile: () => ({
        // The component to load (should be a Promise)
        component: import("./Profile"),
        delay: 200,
    }),
    Reload: () => ({
        // The component to load (should be a Promise)
        component: import("./Reload"),
        delay: 200,
    }),
    SignOut: () => ({
        // The component to load (should be a Promise)
        component: import("./SignOut"),
        delay: 200,
    }),
}